import React from 'react';
import BasicMap from './BasicMap';

export default function Usdm(props) {
	const { mappng } = props;
	const mapTitle = "US Drought Monitor";
	const addtext = " ";

	return (
		<>
			<BasicMap
				mapurl={"https://droughtmonitor.unl.edu/" + mappng}
				addtext={addtext}
				mapTitle={mapTitle}
				foottext={"The <a href='https://droughtmonitor.unl.edu' target='_blank' rel='noopener noreferrer'>U.S. Drought Monitor</a> is jointly produced by the National Drought Mitigation Center at the University of Nebraska-Lincoln, the United States Department of Agriculture, and the National Oceanic and Atmospheric Administration. Map courtesy of NDMC."}
			/>
	   </>
	);
}